import { createActionGroup, props } from "@ngrx/store";


export const FeedbackActions = createActionGroup({
  source: "[Api Feedback Events]",
  events: {
    "Success": props<{ message: string }>(),
    "Failure": props<{ message: string }>(),
    "warning": props<{ summary: string, message: string }>(),
    "EmptyResponse": props<{ message?: string }>(),
  },
});

